import React from 'react';
import { FiExternalLink } from 'react-icons/fi';
import { useWebLocale } from '../../../../contexts/WebLocaleContext';
import { useUserStore } from '../../../../stores/userStore';
import { trackExternalLinkClick } from '../../../../lib/gaEvents';
import { CONTENT_TYPE, PAGE_TYPE } from '../../../../constants/gaEnums';
import apple from '../../../../assets/streaming-services/apple-music.jpg';
import bandcamp from '../../../../assets/streaming-services/bandcamp.jpg';
import './AlbumStreamingLinks.css';

export function albumStreamingLinks(urls) {
  return Object.entries(urls || {})
    .flatMap(([service, value]) => {
      if (service.startsWith('_') || typeof value !== 'string') return [];
      let url;
      try {
        url = new URL(value);
      } catch {
        return [];
      }
      if (!['https:', 'http:'].includes(url.protocol)) return [];
      const normalized = service.toLowerCase().replace(/[-_\s]/g, '');
      const kind = normalized.includes('apple')
        ? 'apple_music'
        : normalized.includes('spotify')
          ? 'spotify'
          : normalized.includes('bandcamp')
            ? 'bandcamp'
            : 'other';
      return [
        {
          service,
          url: url.href,
          kind,
          label:
            { apple_music: 'Apple Music', spotify: 'Spotify', bandcamp: 'Bandcamp' }[kind] ||
            service,
        },
      ];
    })
    .sort(
      (a, b) =>
        ['apple_music', 'spotify', 'bandcamp', 'other'].indexOf(a.kind) -
        ['apple_music', 'spotify', 'bandcamp', 'other'].indexOf(b.kind),
    );
}
export default function AlbumStreamingLinks({ album }) {
  const { locale } = useWebLocale();
  const user = useUserStore((state) => state.user);
  const links = albumStreamingLinks(album.urls);
  if (!links.length) return null;
  return (
    <section className="pp-album-streaming">
      <h2>{locale === 'en' ? 'Listen to Full Album' : '전체 앨범 듣기'}</h2>
      <div className="pp-album-streaming-links">
        {links.map(({ service, url, kind, label }) => (
          <a
            key={service}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={
              locale === 'en' ? `Open the full album in ${label}` : `${label}에서 전체 앨범 열기`
            }
            onClick={() => {
              if (['apple_music', 'spotify'].includes(kind))
                trackExternalLinkClick(
                  {
                    linkType: kind,
                    contentType: CONTENT_TYPE.ALBUM,
                    contentId: album.id,
                    pageType: PAGE_TYPE.REVIEWS_POST,
                  },
                  user,
                );
            }}
          >
            {kind === 'apple_music' || kind === 'bandcamp' ? (
              <img src={kind === 'apple_music' ? apple : bandcamp} alt="" aria-hidden="true" />
            ) : kind === 'spotify' ? (
              <svg width="20" height="20" viewBox="0 0 34 34" aria-hidden="true">
                <circle cx="17" cy="17" fill="#1ED760" r="17" />
                <path
                  d="M8.2 13.1c5.9-1.7 12.9-1.3 18.1 1.3M9.4 17.5c5.1-1.3 11.2-.9 15.8 1.2M10.5 21.5c4.3-1 9.4-.7 13.3 1"
                  fill="none"
                  stroke="#111111"
                  strokeLinecap="round"
                  strokeWidth="2.5"
                />
              </svg>
            ) : (
              <FiExternalLink size={20} aria-hidden="true" />
            )}
            <span>{label}</span>
          </a>
        ))}
      </div>
    </section>
  );
}
